import React from "react";
import { theme } from "src/config";
import styled from "styled-components";
import { Text } from "src/components";
import { debounce } from "src/util/util";


export interface IProgressSliderProps {
  label?:         string,
  max?:           number,
  min?:           number,
  showStepLabel?: "none" | "start_end",
  step?:          number,
  value:          number,
  onChange:       (value: number) => void,
  hidden?:        boolean;
}


export const ProgressSlider = ({
  value,
  min           = 0,
  max           = 100,
  step          = 1,
  showStepLabel = "start_end",
  label         = null,
  onChange      = () => {},
  hidden        = false,
}: IProgressSliderProps) => {

  const [_value, setValue] = React.useState<number>(value);
  const debouncedOnChange = React.useCallback(debounce((val: number) => onChange(val)), [onChange]);

  React.useEffect(() => {
    if(value != _value) {
      setValue(value)
    }
  }, [value]);
  
  return (
    <>
    {!hidden &&
      <Container>
      {label && <Text size="small" style={{marginBottom: "0.5rem"}}>{label}</Text>}
      <Slider 
        min      = {min}
        max      = {max}
        value    = {_value}
        onChange = {(e) => setValue(Number(e.target.value))}
        step     = {step}
        onMouseUp = { () => debouncedOnChange(_value)}
      />
      {showStepLabel !== "none" &&
        <StepLabelContainer>
          <Text size="xsmall" color={theme.color.slate11}>{''}</Text>
          {_value && (
            <Text size="xsmall" color={theme.color.slate11}>{_value}%</Text>
          )}
          <Text size="xsmall" color={theme.color.slate11}>{''}</Text>
        </StepLabelContainer>
      }
    </Container>
    
    }

    </>
  );
}

const Container = styled.div`
`;

const StepLabelContainer = styled.div`
  display:         flex;
  flex-direction:  row;
  justify-content: space-between;
  margin:          0rem 0.25rem 0rem 0.5rem;
`;

const Slider = styled.input.attrs({ type: 'range' })`
  width:              100%;
  -webkit-appearance: none;
  -moz-appearance:    none;
  outline:            0;
  height:             0.6rem;
  border-radius:      4rem;
  background:         ${(props) =>
    `linear-gradient(to right, #0C668E 0%, #0C668E ${props.value}%, #E6E8EB ${props.value}%, #E6E8EB 100%);`};

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    width:              1.6rem;
    height:             1.6rem;
    background-image:   radial-gradient(circle, #0C668E 45%, #FFFFFF 40%);
    border-radius:      50%;
    box-shadow:         0 2px 6px rgba(0, 0, 0, 0.2);
    cursor:             pointer;
  }

  ::-moz-range-thumb {
    width:            1.6rem;
    height:           1.6rem;
    -moz-appearance:  none;
    background-image: radial-gradient(circle, #f7f7fc 40%, #0C668E 45%);
    border-radius:    50%;
    border:           1px solid ${theme.color.primaryBorder};
    cursor:           pointer;
  }
`;
